import * as T from 'prop-types';

import { Label, Text } from '@olist/united';

const ReadOnlyField = ({ label, placeholder, value = '' }) => {
  return (
    <>
      <Label>
        <Text>{label}</Text>
      </Label>
      <Text textAlign="center" color="foundation.shadeDark" mt={[3]}>
        <span aria-label={label}>{value || placeholder || '--'}</span>
      </Text>
    </>
  );
};

ReadOnlyField.propTypes = {
  label: T.string.isRequired,
  placeholder: T.string,
  value: T.string,
};

ReadOnlyField.defaultProps = {
  value: '',
  placeholder: '',
};

export { ReadOnlyField };
